import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const RedirectToWork = ({ path }) => {
  const params = useParams();
  
  useEffect(() => {
    let redirectUrl = process.env.REACT_APP_WORK_URL;
    
    if (path) {
      // Replace route parameters in the path
      let finalPath = path;
      Object.keys(params).forEach(key => {
        finalPath = finalPath.replace(`:${key}`, params[key]);
      });
      redirectUrl += finalPath;
    }
    
    window.location.href = redirectUrl;
  }, [path, params]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      backgroundColor: '#f9fafc'
    }}>
      <div style={{ fontSize: '18px', marginBottom: '16px' }}>Redirecting to work application...</div>
      <div style={{ fontSize: '14px', color: '#64748b' }}>You will be redirected automatically</div>
    </div>
  );
};

export default RedirectToWork;